import React from 'react';
import { Typography } from '@mui/material';

import googlePlayBadge from '../../assets/svg/google-play-store.svg';
import iosAppStoreBadge from '../../assets/svg/ios-app-store.svg';

import './get-mobile-app-from-both-app-stores.scss';
import { GOOGLE_PLAY_URL, IOS_APP_STORE_URL } from '../../helpers/app-store-links';

const block = 'get-mobile-app-from-both-app-stores';

interface GetMobileAppFromBothAppStoresProps {
  optionalTextContent?: string | null;
  compact?: boolean;
  style?: React.CSSProperties;
}

export const GetMobileAppFromBothAppStores: React.FC<GetMobileAppFromBothAppStoresProps> = ({
  optionalTextContent,
  compact,
  style,
}) => {
  return (
    <div className={`${block}-wrapper`} style={style}>
      <div className={`${block}${compact ? ` ${block}--compact` : ''}`}>
        {optionalTextContent && (() => {
          const [ heading, ...bodyLines ] = optionalTextContent.split('\\n');
          const body = bodyLines.join('\n');
          return (
            <>
              <Typography variant="h4" className={`${block}__heading`}>
                {heading}
              </Typography>
              {body && (
                <Typography variant="body1" whiteSpace="pre-line" className={`${block}__body`}>
                  {body}
                </Typography>
              )}
            </>
          );
        })()}
        <div className={`${block}__badges`}>
          <a
            href={IOS_APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={`${block}__badge-link`}
          >
            <img src={iosAppStoreBadge} alt="Download on the App Store" />
          </a>
          <a
            href={GOOGLE_PLAY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={`${block}__badge-link`}
          >
            <img src={googlePlayBadge} alt="Get it on Google Play" />
          </a>
        </div>
      </div>
    </div>
  );
};
